<template >
  <div class="indication-wrap">
    <div class="inner">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {},
  mounted() {
    document.body.style.overflow = 'hidden'
    setTimeout(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }, 300)
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
  },
}
</script>
<style lang='stylus' scoped>
.indication-wrap {
  left: 0;
  top: 0;
  z-index: 100000;
  background: rgba(0, 0, 0, 0.3);
  width: 100vw;
  height: 100vh;
  position: fixed;

  >.inner {
    height: 100%;
    padding: 0;
    width: 960px;
    margin: auto;
    position: relative;
  }
}
</style>
